module.exports = __webpack_public_path__ + "img/ironshore_logo-white_mobile.c0b96a55.png";